import IPrice from 'interfaces/products/IPrice';

import { EUR } from 'services/enums/currencies';

// The pair of a price type and a unit is given once; a type can have several units
export const hasDuplicatePrice = (priceFormValues: IPrice[]): boolean =>
  priceFormValues.some((price, index) =>
    priceFormValues.some(
      (other, otherIndex) =>
        otherIndex < index &&
        other.type === price.type &&
        other.siUnit === price.siUnit
    )
  );

// A new price row: the first price type not given yet, or else the first type with a unit
// not given for it
const getEmptyPrice = (
  priceFormValues: IPrice[],
  unitsList: string[],
  priceTypesList: string[]
): IPrice[] => {
  const isGiven = (type: string, unit: string) =>
    priceFormValues.some(
      (priceFormValue) =>
        priceFormValue.type === type && priceFormValue.siUnit === unit
    );
  const unusedType = priceTypesList.find(
    (priceType) =>
      !priceFormValues.some(
        (priceFormValue) => priceFormValue.type === priceType
      )
  );
  const type = unusedType ?? priceTypesList[0];
  const siUnit = unitsList.find((unit) => !isGiven(type, unit)) ?? unitsList[0];

  const emptyValues: IPrice = {
    value: '0',
    siUnit,
    type,
    currency: EUR,
  };
  return [...priceFormValues, emptyValues];
};

export default getEmptyPrice;
